//TODO: is currently not used!
'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');
var Common = require('../common');

module.exports = Backbone.View.extend({

    initialize: function () {
        console.log('Initializing EventView');

        //Set menu
        Common.MainMenuEntries.setSelected('event');
    },


    /////////////////////////////////////
    // Render
    /////////////////////////////////////
    template: _.template($('#event-template').html(), { interpolate: /\{\{(.+?)\}\}/g }),
    render: function () {
        $(this.el).html(this.template());
        $(function () {
            $('#pageTitle').html('Schedule event');
        });
        return this;
    },

    /////////////////////////////////////
    // Destroy
    /////////////////////////////////////
    destroy: function () {
        this.remove();
        return Backbone.View.prototype.remove.apply(this, arguments);
    }
});